import { render, staticRenderFns } from "./YogaStayPhone.vue?vue&type=template&id=61bc3648&scoped=true&"
import script from "./YogaStayPhone.vue?vue&type=script&lang=js&"
export * from "./YogaStayPhone.vue?vue&type=script&lang=js&"
import style0 from "./YogaStayPhone.vue?vue&type=style&index=0&id=61bc3648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bc3648",
  null
  
)

export default component.exports